import { useEffect, useMemo } from "react";
import CustomButton from "../../../../components/CustomButton";
import ModalWrapper from "../../../../components/Modal/ModalWrapper";
import LoadingIndicator from "../../../../components/misc/LoadingIndicator";
import TableWidget from "../../../../components/tables/TableWidget";
import { getRecallClientReceipts } from "../../../../redux/api/recall.api";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { clearRecallClientReceipts } from "../../../../redux/reducer/recall.reducer";
import Text from "../../../../styleguide/Text";
import {
  getRecallClientReceiptsTableData,
  recallClientReceiptsTableHeader,
} from "./tableConfigs/recallClientReceiptsTableConfig";

function RecallClientReceiptsModal({
  idCampaign,
  clientPlId,
  pharmacyName,
  handleClose,
}: {
  idCampaign: number;
  clientPlId: number;
  pharmacyName: string;
  handleClose: () => void;
}) {
  const dispatch = useAppDispatch();
  const clientReceipts = useAppSelector((state) => state.recall.clientReceipts);

  useEffect(() => {
    dispatch(getRecallClientReceipts({ idCampaign, clientPlId }));
    return () => {
      dispatch(clearRecallClientReceipts());
    };
  }, [dispatch, idCampaign, clientPlId]);

  const data =
    clientReceipts.data?.idCampaign === idCampaign &&
    clientReceipts.data.clientPlId === clientPlId
      ? clientReceipts.data
      : null;
  const tableData = useMemo(
    () => getRecallClientReceiptsTableData(data?.receipts ?? []),
    [data?.receipts],
  );

  return (
    <ModalWrapper
      show
      title={`Cantitati primite "${pharmacyName}"`}
      modalSize="xl"
      handleClose={handleClose}>
      {clientReceipts.isError ? (
        <div>
          <Text role="alert" className="mb-4 text-danger">
            {clientReceipts.errorMessage}
          </Text>
          <CustomButton
            variant="outlined"
            onClick={() =>
              dispatch(getRecallClientReceipts({ idCampaign, clientPlId }))
            }>
            Reincarca
          </CustomButton>
        </div>
      ) : clientReceipts.isLoading || !data ? (
        <div
          className="flex min-h-[180px] items-center justify-center"
          aria-label="Se incarca cantitatile primite">
          <LoadingIndicator />
        </div>
      ) : (
        <TableWidget
          className="[&_thead_th]:text-left"
          tableHeaderData={recallClientReceiptsTableHeader}
          tableItemsData={tableData}
          withTablePagination={false}
          withRouteParams={false}
          emptyTableLabel="Nu exista cantitati primite pentru aceasta farmacie"
        />
      )}
    </ModalWrapper>
  );
}

export default RecallClientReceiptsModal;
